export default __webpack_public_path__ + "static/media/tennis-league-cover.ce998c99.png";